import { User } from "@auth0/auth0-react";

// LQC-2254 - the logged-in user's identity for outbound payloads. There is no user
// or profile store in the app: everything comes off the Auth0 user object, and the
// entity arrives as a custom claim. Centralised here so the claim URL is written once
// (it is currently repeated inline in AxeCreationSERVICES and the right-click export
// helpers - both should move onto these functions).

export const AUTH0_CUSTOMER_CLAIM = "https://liquiditycube.net/customer";

// Trader name for clientDetails.traderName. Standard OIDC claim.
export function returnTraderName(user: User | undefined): string {
  return user?.name ?? "";
}

// The user's own entity code. Only a fallback for clientDetails.originatingEntity -
// prefer the selected portfolio's customerCode, which is the format the back end has
// been proven to accept ("ARD-UK").
export function returnUserEntity(user: User | undefined): string {
  const customer = user?.[AUTH0_CUSTOMER_CLAIM];
  return customer?.primary ?? "";
}
